"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ByteSequence = void 0;
class ByteSequence {
    constructor(base64Value) {
        this.base64Value = base64Value;
    }
    toBase64() {
        return this.base64Value;
    }
}
exports.ByteSequence = ByteSequence;
//# sourceMappingURL=types.js.map